"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debug = debug;
function debug(message, ...args) {
    if (process.env.KRAUTERS_ENVIRONMENT_DEBUG) {
        console.debug('[@krauters/environment]', message, ...args);
    }
}
//# sourceMappingURL=utils.js.map